import { useQueryClient, useMutation } from 'react-query'
import { UserType } from '../../../../enumns/userType'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { type UserPersistence } from '../../../../types/persistence/user-persistence'
import { api } from '../../../api'

const createExpert = async (data: UserPersistence) => {
  const response = await api.post<ExpertDomain>('/experts', data)
  return response.data
}

const createExpertFromAdmin = async (data: UserPersistence) => {
  const response = await api.post<ExpertDomain>('/experts/from-admin', data)
  return response.data
}

export const useExpertCreateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn (data: UserPersistence) {
      return createExpert({ ...data, type: UserType.EXPERT })
    },
    onSuccess (data: ExpertDomain) {
      queryClient.setQueryData(['expert', data.id], data)
    }
  })
}

export const useExpertCreateFromAdminMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn (data: UserPersistence) {
      return createExpertFromAdmin({ ...data, type: UserType.EXPERT })
    },
    onSuccess (data: ExpertDomain) {
      queryClient.setQueryData(['expert', data.id], data)
    }
  })
}
